import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { BsDashCircle } from 'react-icons/bs';

import './HeaderDetail.scss';
import { eventPendingAssignmentName } from '../../../utils/dataStatus';

const HeaderDetail = ({ data, handleRemoveWell, disabledDeleteWell, showAlertWell }) => (
  <div className="d-flex justify-content-between">
    <div className="well-header-detail">
      <h6 className="me-2">Ubicación</h6>
      <h6 className="pill light">{data.well?.label}</h6>
      {!!data.event && <h6 className="pill dark mx-2">{data.event?.sigla}</h6>}
      {data.event?.nombre === eventPendingAssignmentName && (
        <h6 className="pill dark mx-2">{data.event?.nombre}</h6>
      )}
      {!!data.team && <h6 className="pill light me-2">{data.team?.label}</h6>}
      {showAlertWell && (
        <h6
          style={{
            color: 'red',
            fontWeight: '200'
          }}
        >
          Ingrese el mismo evento para todos los pozos
        </h6>
      )}
    </div>
    {!disabledDeleteWell && (
      <Button
        colorIcon="danger"
        icon={BsDashCircle}
        onClick={handleRemoveWell}
        type="button"
        variant="light-gray"
        widthButton="42px"
      />
    )}
  </div>
);

HeaderDetail.propTypes = {
  data: PropTypes.shape({
    well: PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.number
    }),
    event: PropTypes.shape({
      sigla: PropTypes.string,
      nombre: PropTypes.string
    }),
    team: PropTypes.shape({
      label: PropTypes.string
    })
  }),
  handleRemoveWell: PropTypes.func,
  disabledDeleteWell: PropTypes.bool,
  showAlertWell: PropTypes.bool
};

HeaderDetail.defaultProps = {
  data: {
    well: {
      label: '-',
      id: 0
    },
    event: {
      sigla: '-',
      nombre: '-'
    },
    team: {
      label: '-'
    }
  },
  handleRemoveWell: () => {},
  disabledDeleteWell: false,
  showAlertWell: false
};

export default HeaderDetail;
